import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { TestQueryService } from "../../test-query.service"

@Injectable({
  providedIn: 'root'
})
export class GetpicService {

  constructor(private sanitizer:DomSanitizer,public ml:TestQueryService) { }
  // 创建图形
  createGra(datas?:Object|undefined){
    let urlData = this.ml.rootIp+":3000/dashboard/script/scripteds.js?theme="+this.ml.bgColor+"&kiosk&datas="+JSON.stringify(datas);
    return this.trustUrl(urlData);
  }
  // 转换成能够被读取的  url
  trustUrl(urls:any) {
     return this.sanitizer.bypassSecurityTrustResourceUrl(urls);
  }

  // 数据源
  // 账号  密码  数据库名称   表名称   
}
 